import STRINGS from '../assets/Strings';

const useStrings = (): [typeof STRINGS] => [STRINGS];

export default useStrings;
